import {} from "../actions/types";

const initialState = {
	loading: true,
	trashList: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
		case "GET_TRASH_REQUEST": {
			return {
				...state,
				loading: true,
			};
		}

		case "GET_TRASH_SUCCESS": {
			return {
				...state,
				loading: false,
				trashList: action.payload.trashList,
			};
		}

		case "HIDE_ITEMS_PERM_DELETE_STARTED_WITH": {
			return {
				...state,
				trashList: action.payload.trashList,
			};
		}

		default:
			return state;
	}
}
